import { useEffect, useMemo, useState } from "react";

import { ensureCsrfToken } from "../../api";

import Swal from "sweetalert2";

const MATCHING_OPTIONS = ["Invoice Number", "PO Number", "GRN Number"];
const NARRATION_FIELDS = [
  { value: "invoice_no", label: "Invoice No" },
  { value: "vendor_name", label: "Vendor Name" },
  { value: "amount", label: "Amount" },
  { value: "date", label: "Date" },
  { value: "po_no", label: "PO No" },
];




const DEFAULT_OPEN_SECTIONS = {
  posting: true,
  
  matching: false,
  reporting: false,
  
  unplanned: false,
  
  matchingLogic: false,
  uploadRights: false,
  companyPan: false,
  materialService: false,
};

function getCurrentFY() {
  const today = new Date();
  return today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
}

function getFYOptions() {
  const currentFY = getCurrentFY();
  return Array.from({ length: 10 }, (_, index) => {
    const fy = currentFY - index;
    return {
      value: String(fy),
      label: `FY ${fy}-${String(fy + 1).slice(-2)}`,
    };
  });
}

function getMonthOptions(selectedFY) {
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentFY = getCurrentFY();

  const months = [
    ["April", "3"],
    ["May", "4"],
    ["June", "5"],
    ["July", "6"],
    ["August", "7"],
    ["September", "8"],
    ["October", "9"],
    ["November", "10"],
    ["December", "11"],
    ["January", "0"],
    ["February", "1"],
    ["March", "2"],
  ];

  return months.filter(([, index]) => {
    if (String(selectedFY) !== String(currentFY)) {
      return true;
    }

    const monthIndex = Number(index);
    return currentMonth >= 3
      ? monthIndex <= currentMonth
      : monthIndex <= currentMonth || monthIndex >= 3;
  });
}

function getCurrentFYMonthOptions() {
  const today = new Date();
  const currentMonth = today.getMonth();
  const months = [
    { name: "April", index: "3" },
    { name: "May", index: "4" },
    { name: "June", index: "5" },
    { name: "July", index: "6" },
    { name: "August", index: "7" },
    { name: "September", index: "8" },
    { name: "October", index: "9" },
    { name: "November", index: "10" },
    { name: "December", index: "11" },
    { name: "January", index: "0" },
    { name: "February", index: "1" },
    { name: "March", index: "2" },
  ];

  return months.filter((month) => {
    const monthIndex = Number(month.index);
    if (currentMonth >= 3) {
      return monthIndex >= 3 && monthIndex <= currentMonth;
    }
    return monthIndex >= 3 || monthIndex <= currentMonth;
  });
}

function createDefaultConfig() {
  const currentFY = String(getCurrentFY());
  const currentMonths = getCurrentFYMonthOptions();
  const previousMonths = getMonthOptions(currentFY);
  

  return {
    monthly_close: {
      monthly_close: "N",
      date_of_entry: "system",
      auto_on_date: "5",
      auto_or_manual: "automatic",
      manual_close: {
        PreviousYr: currentFY,
        PreviousYrMonth: previousMonths[0]?.[1] || "3",
        CurrentYrMonth: currentMonths[0]?.index || "3",
        scenario_same_month: "system",
        scenario_books_closed: "first_day",
        scenario_books_not_closed: "last_date",
      },
      auto_close: {
        scenario_same_month: "system",
        scenario_books_closed: "first_day",
        scenario_books_not_closed: "last_date",
      },
    },
    
    gst_input_expired:"31/10",
    tax_period_expired:"31/03",
    matching: {
      matching_type: "3way",
      matching_preference: {
        1: "Invoice Number",
        2: "GRN Number",
        3: "PO Number",
      },
    },
    currency: {
      reporting_currency_name: "",
      reporting_currency_code: "",
      exchange_rate_tolerance: "",
    },
    narration: {
      fields: ["invoice_no","vendor_name","date","po_no"],
      symbol: "!",
    },
    
    unplanned_cost: {
      add_to_material_service: "Y",
      processor: {
        threshold_amount: "1000",
        threshold_percent: "2",
        condition: "AND",
      },
      checker: {
        threshold_amount: "1000",
        threshold_percent: "2",
        condition: "AND",
      },
    },
    threshold: {
      turnover_above_threshold: "Y",
      threshold_amount: "5000000",
      wt_rate: "0.1",
    },
    service_entry_migo: {
      service_entry_migo: "",
    },
    matching_logic: {
      fuzzyratio: "50",
      sementicratio: "50",
      matching_tolerance: "80",
    },
    data_upload_rights: {
      uploader: false,
      processor: false,
      checker: false,
    },
    companyPan: "",
    material_service_codes: {
      material: [],
      service: [],
    },
    invoice_value_exception: {
      lower_limit: "10",
      upper_limit: "1000000",
    },
    address_matching_threshold: {
      fuzzyratio: "50",
      sementicratio: "50",
      matching_tolerance: "80",
    },
    
  };
}

function mergeLoadedConfig(payload) {
  const next = createDefaultConfig();
  if (!payload) {
    return next;
  }

  if (payload.monthly_close) {
    next.monthly_close = {
      ...next.monthly_close,
      ...payload.monthly_close,
      manual_close: {
        ...next.monthly_close.manual_close,
        ...(payload.monthly_close.manual_close || {}),
      },
      auto_close: {
        ...next.monthly_close.auto_close,
        ...(payload.monthly_close.auto_close || {}),
      },
    };
  }

  
  
  if (payload.gst_input_expired) {
    next.gst_input_expired = payload.gst_input_expired
  }

  if (payload.tax_period_expired) {
    next.tax_period_expired = payload.tax_period_expired
  }

  if (payload.matching) {
    next.matching = {
      ...next.matching,
      ...payload.matching,
      matching_preference: {
        ...next.matching.matching_preference,
        ...(payload.matching.matching_preference || {}),
      },
    };
  }

  if (payload.currency) {
    next.currency = { ...next.currency, ...payload.currency };
  }

  if (payload.narration) {
    next.narration = {
      ...next.narration,
      ...payload.narration,
      fields: Array.isArray(payload.narration.fields) ? payload.narration.fields : [],
    };
  }

  

  if (payload.unplanned_cost) {
    next.unplanned_cost = {
      ...next.unplanned_cost,
      ...payload.unplanned_cost,
      processor: {
        ...next.unplanned_cost.processor,
        ...(payload.unplanned_cost.processor || {}),
      },
      checker: {
        ...next.unplanned_cost.checker,
        ...(payload.unplanned_cost.checker || {}),
      },
    };
  }

  
  if (payload.service_entry_migo) {
    next.service_entry_migo = { ...next.service_entry_migo, ...payload.service_entry_migo };
  }

  if (payload.matching_logic_ratio) {
    next.matching_logic = {
      ...next.matching_logic,
      ...payload.matching_logic_ratio,
    };
  }

  if (payload.address_matching_threshold) {
    next.address_matching_threshold = {
      ...next.address_matching_threshold,
      ...payload.address_matching_threshold,
    };
  }

  if (payload.data_upload_rights) {
    next.data_upload_rights = {
      ...next.data_upload_rights,
      ...payload.data_upload_rights,
    };
  }

  if (typeof payload.pans === "string") {
    next.companyPan = payload.pans;
  }

  if (payload.material_service_codes) {
    next.material_service_codes = {
      material: Array.isArray(payload.material_service_codes.material)
        ? payload.material_service_codes.material
        : [],
      service: Array.isArray(payload.material_service_codes.service)
        ? payload.material_service_codes.service
        : [],
    };
  }

  return next;
}

async function parseJsonResponse(response) {
  const contentType = (response.headers.get("content-type") || "").toLowerCase();
  if (contentType.includes("application/json")) {
    return {
      isJson: true,
      payload: await response.json(),
      text: "",
    };
  }
  return {
    isJson: false,
    payload: null,
    text: await response.text(),
  };
}

function normalizeNonJsonError(response, text, fallback) {
  const body = String(text || "");
  const lower = body.toLowerCase();
  const looksLikeHtml = lower.includes("<html") || lower.includes("<!doctype html");
  const looksLikeLogin = lower.includes("miro app login") || lower.includes("name=\"password\"");

  if (response.redirected || response.url.includes("next=") || looksLikeLogin) {
    return "Session is not authenticated. Please login again.";
  }
  if (looksLikeHtml) {
    return fallback;
  }
  return body || fallback;
}

function Section({ title, subtitle, open, onToggle, children }) {
  return (
    <article className="config-card">
      <button className="config-card__head" type="button" onClick={onToggle}>
        <div>
          <div className="config-card__title">{title}</div>
          <div className="config-card__subtitle">{subtitle}</div>
        </div>
        <span className="config-card__toggle">{open ? "Hide" : "Show"}</span>
      </button>
      {open ? <div className="config-card__body">{children}</div> : null}
    </article>
  );
}

function RadioGroup({ name, value, options, onChange }) {
  return (
    <div className="config-inline">
      {options.map((option) => (
        <label key={option.value} className="config-choice">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
}

export default function ConfigurationView() {
  const [config, setConfig] = useState(createDefaultConfig);
  const [openSections, setOpenSections] = useState(DEFAULT_OPEN_SECTIONS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  const fyOptions = useMemo(() => getFYOptions(), []);
  const previousYearMonthOptions = useMemo(
    () => getMonthOptions(config.monthly_close.manual_close.PreviousYr),
    [config.monthly_close.manual_close.PreviousYr],
  );
  const currentFyMonthOptions = useMemo(() => getCurrentFYMonthOptions(), []);

  const preference1 = config.matching.matching_preference[1];
  const preference2Choices = MATCHING_OPTIONS.filter((item) => item !== preference1);
  const preference2 = preference2Choices.includes(config.matching.matching_preference[2])
    ? config.matching.matching_preference[2]
    : preference2Choices[0];
  const preference3 = MATCHING_OPTIONS.find(
    (item) => item !== preference1 && item !== preference2,
  );

  useEffect(() => {
    setConfig((current) => ({
      ...current,
      matching: {
        ...current.matching,
        matching_preference: {
          1: preference1,
          2: preference2,
          3: preference3,
        },
      },
    }));
  }, [preference1, preference2, preference3]);

  useEffect(() => {
    let cancelled = false;

    async function loadConfiguration() {
      setLoading(true);
      setError("");

      try {
        const response = await fetch("/api/configuration/", {
          credentials: "include",
          headers: {
            Accept: "application/json",
          },
        });
        const { isJson, payload, text } = await parseJsonResponse(response);
        if (!isJson) {
          throw new Error(
            normalizeNonJsonError(
              response,
              text,
              "Unable to load saved configuration.",
            ),
          );
        }

        if (!cancelled) {
          if (payload.status === "success") {            
            setConfig(mergeLoadedConfig(payload.data));
          }
          setStatus("");
        }
      } catch (requestError) {
        if (!cancelled) {
          setError(requestError.message || "Unable to load saved configuration.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadConfiguration();

    return () => {
      cancelled = true;
    };
  }, []);

  function toggleSection(sectionKey) {
    setOpenSections((current) => ({
      ...current,
      [sectionKey]: !current[sectionKey],
    }));
  }

  function updateTopLevel(key, value) {
    setConfig((current) => ({
      ...current,
      [key]: value,
    }));
  }

  function updateSection(sectionKey, field, value) {
    setConfig((current) => ({
      ...current,
      [sectionKey]: {
        ...current[sectionKey],
        [field]: value,
      },
    }));
  }

  function updateNested(sectionKey, nestedKey, field, value) {
    setConfig((current) => ({
      ...current,
      [sectionKey]: {
        ...current[sectionKey],
        [nestedKey]: {
          ...current[sectionKey][nestedKey],
          [field]: value,
        },
      },
    }));
  }

 

  function handleNarrationFieldToggle(value) {
    setConfig((current) => {
      const alreadySelected = current.narration.fields.includes(value);
      return {
        ...current,
        narration: {
          ...current.narration,
          fields: alreadySelected
            ? current.narration.fields.filter((item) => item !== value)
            : [...current.narration.fields, value],
        },
      };
    });
  }

  function buildPayload() {
    return {
      monthly_close: config.monthly_close,
      baseline: config.baseline,
      blocking: config.blocking,
      matching: {
        ...config.matching,
        matching_preference: {
          1: preference1,
          2: preference2,
          3: preference3,
        },
      },
      currency: config.currency,
      narration: config.narration,
      duplicate_check: config.duplicate_check,
      unplanned_cost: config.unplanned_cost,
      threshold: config.threshold,
      service_entry_migo: config.service_entry_migo,
      matching_logic: config.matching_logic,
      address_matching_threshold: config.address_matching_threshold,
      data_upload_rights: config.data_upload_rights,
      companyPan: config.companyPan.trim().toUpperCase(),
      material_service_codes: {
        material: config.material_service_codes.material,
        service: config.material_service_codes.service,
      },
      blocking_activate: config.blocking_activate,
      gst_input_expired: config.gst_input_expired,
      tax_period_expired: config.tax_period_expired,
      invoice_value_exception: {
        lower_limit: config.invoice_value_exception?.lower_limit ?? "",
        upper_limit: config.invoice_value_exception?.upper_limit ?? "",
      },
    };
  }

  async function handleSave() {
    setSaving(true);
    const pan = config.companyPan?.trim().toUpperCase();

    if (!pan || !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid PAN",
        text: "Please enter a valid Company PAN.",
      });
      return;
    }
    try {
      
      
      const csrfToken = await ensureCsrfToken();
      const formData = new FormData();
      formData.append("payload", JSON.stringify(buildPayload()));

      const response = await fetch("/api/configuration/save/", {
        method: "POST",
        headers: {
          "X-CSRFToken": csrfToken,
          Accept: "application/json",
        },
        credentials: "include",
        body: formData,
      });

      const { isJson, payload, text } = await parseJsonResponse(response);
      if (!isJson) {
        throw new Error(
          normalizeNonJsonError(
            response,
            text,
            "Unable to save configuration.",
          ),
        );
      }

      if (!response.ok || payload.status !== "success") {
        throw new Error(payload.message || "Unable to save configuration.");
      }
      Swal.fire({
        icon: "success",
        title: "Success",
        text: payload.message || "Configuration saved successfully.",
        confirmButtonText: "OK",
      });
      
    } catch (requestError) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: requestError.message || "Unable to save configuration.",
        confirmButtonText: "OK",
      });
      
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return <div className="workspace-panel">Loading configuration…</div>;
  }

  return (
    <section className="config-view">
      <div className="config-view__header workspace-panel">
        <div>
          <p className="eyebrow">Basic Configurations</p>
          <h2>Accounting Configuration</h2>
          <p className="config-view__intro">
            PO Invoice: Configure accounting rules and validations for Purchase Order-based invoices, including matching, 
            verification, and transaction posting.
          </p>
        </div>
        <button className="primary-button" type="button" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Submit Configuration"}
        </button>
      </div>

      {status ? <div className="config-banner config-banner--success">{status}</div> : null}
      {error ? <div className="config-banner config-banner--error">{error}</div> : null}

      <Section
        title="1. Posting Date"
        subtitle="Monthly close and posting date rules"
        open={openSections.posting}
        onToggle={() => toggleSection("posting")}
      >
        <div className="config-grid">
          <div className="config-field">
            <label>Keep provision of monthly close of WFS?</label>
            <RadioGroup
              name="monthly_close"
              value={config.monthly_close.monthly_close}
              options={[
                { value: "N", label: "No" },
                { value: "Y", label: "Yes" },
              ]}
              onChange={(value) => updateSection("monthly_close", "monthly_close", value)}
            />
          </div>

          {config.monthly_close.monthly_close === "N" ? (
            <div className="config-field">
              <label>If No, Date of Entry</label>
              <select
                value={config.monthly_close.date_of_entry}
                onChange={(event) => updateSection("monthly_close", "date_of_entry", event.target.value)}
              >
                <option value="system">System Date</option>
                <option value="invoice">Invoice Date</option>
                <option value="migo">MIGO Date</option>
              </select>
            </div>
          ) : (
            <div className="config-field">
              <label>If Yes, Automatic or Manual?</label>
              <select
                value={config.monthly_close.auto_or_manual}
                onChange={(event) => updateSection("monthly_close", "auto_or_manual", event.target.value)}
              >
                <option value="automatic">Automatic</option>
                <option value="manual">Manual</option>
              </select>
            </div>
          )}
        </div>

        {config.monthly_close.monthly_close === "Y" ? (
          <>
            {config.monthly_close.auto_or_manual === "automatic" ? (
              <div className="config-grid">
                <div className="config-field">
                  <label>Automatic on</label>
                  <input
                    type="number"
                    min="1"
                    max="28"
                    value={config.monthly_close.auto_on_date}
                    onChange={(event) => updateSection("monthly_close", "auto_on_date", event.target.value)}
                    placeholder="day of month"
                  />
                </div>
              </div>
            ) : (
              <div className="config-grid">
                <div className="config-field">
                  <label>Select Previous Year</label>
                  <select
                    value={config.monthly_close.manual_close.PreviousYr}
                    onChange={(event) => {
                      
                      updateNested(
                        "monthly_close",
                        "manual_close",
                        "PreviousYrMonth",
                        event.target.value
                      );
                    }}
                  >
                    {fyOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="config-field">
                  <label>Select Previous Year Month</label>
                  <select
                    value={config.monthly_close.manual_close.PreviousYrMonth ?? ""}
                    onChange={(event) =>
                      updateNested("monthly_close", "manual_close", "PreviousYrMonth", event.target.value)
                    }
                  >
                    {previousYearMonthOptions.map(([name, value]) => (
                      <option key={value} value={value}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="config-field">
                  <label>Select Current Year Month</label>
                  <select
                    value={config.monthly_close.manual_close.CurrentYrMonth ?? ""}
                    onChange={(event) =>
                      updateNested("monthly_close", "manual_close", "CurrentYrMonth", event.target.value)
                    }
                  >
                    {currentFyMonthOptions.map((option) => (
                      <option key={option.index} value={option.index}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="config-grid">
              <div className="config-field">
                <label>IF month(invoice) = month(entry)</label>
                <select
                  value={
                    config.monthly_close.auto_or_manual === "manual"
                      ? config.monthly_close.manual_close.scenario_same_month
                      : config.monthly_close.auto_close.scenario_same_month
                  }
                  onChange={(event) =>
                    updateNested(
                      "monthly_close",
                      config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close",
                      "scenario_same_month",
                      event.target.value,
                    )
                  }
                >
                  <option value="system">System Date</option>
                  <option value="invoice">Invoice Date</option>
                  <option value="migo">MIGO Date</option>
                </select>
              </div>

              <div className="config-field">
                <label>IF month(invoice) != month(entry), books closed</label>
                <select
                  value={
                    config.monthly_close.auto_or_manual === "manual"
                      ? config.monthly_close.manual_close.scenario_books_closed
                      : config.monthly_close.auto_close.scenario_books_closed
                  }
                  onChange={(event) =>
                    updateNested(
                      "monthly_close",
                      config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close",
                      "scenario_books_closed",
                      event.target.value,
                    )
                  }
                >
                  <option value="system">System Date</option>
                  <option value="first_day">First Day of Month</option>
                  <option value="block_entry">Block The Entry</option>
                </select>
              </div>

              <div className="config-field">
                <label>IF month(invoice) != month(entry), books not closed</label>
                <select
                  value={
                    config.monthly_close.auto_or_manual === "manual"
                      ? config.monthly_close.manual_close.scenario_books_not_closed
                      : config.monthly_close.auto_close.scenario_books_not_closed
                  }
                  onChange={(event) =>
                    updateNested(
                      "monthly_close",
                      config.monthly_close.auto_or_manual === "manual" ? "manual_close" : "auto_close",
                      "scenario_books_not_closed",
                      event.target.value,
                    )
                  }
                >
                  <option value="last_date">Last date of invoice month</option>
                  <option value="system">System Date</option>
                  <option value="invoice">Invoice Date</option>
                  <option value="migo">MIGO Date</option>
                </select>
              </div>
            </div>
          </>
        ) : null}
      </Section>


      <Section
        title="2. Matching Type"
        subtitle="Choose 2-way or 3-way invoice verification"
        open={openSections.matching}
        onToggle={() => toggleSection("matching")}
      >
        <div className="config-grid">
          <div className="config-field">
            <label>Matching Type</label>
            <RadioGroup
              name="matching_type"
              value={config.matching.matching_type}
              options={[
                { value: "3way", label: "3-way" },
                { value: "2way", label: "2-way" },
              ]}
              onChange={(value) => updateSection("matching", "matching_type", value)}
            />
          </div>
        </div>

        <div className="config-grid">
          <div className="config-field">
            <label>Preference 1</label>
            <select
              value={preference1}
              onChange={(event) =>
                updateSection("matching", "matching_preference", {
                  ...config.matching.matching_preference,
                  1: event.target.value,
                })
              }
            >
              {MATCHING_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="config-field">
            <label>Preference 2</label>
            <select
              value={preference2}
              onChange={(event) =>
                updateSection("matching", "matching_preference", {
                  ...config.matching.matching_preference,
                  2: event.target.value,
                })
              }
            >
              {preference2Choices.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="config-field">
            <label>Preference 3</label>
            <input value={preference3} readOnly />
          </div>
        </div>
      </Section>

      <Section
        title="3. Reporting Currency"
        subtitle="Currently under development for import invoices"
        open={openSections.reporting}
        onToggle={() => toggleSection("reporting")}
      >
        <p className="config-note">
          Reporting currency handling is still under development in the original Django template, so
          this React version keeps the same placeholder behavior.
        </p>
      </Section>

      

      <Section
        title="4. Narration String"
        subtitle="Narration composition"
        open={openSections.narration}
        onToggle={() => toggleSection("narration")}
      >
        <div className="config-field">
          <label>Narration fields</label>
          <div className="config-check-grid">
            {NARRATION_FIELDS.map((field) => (
              <label key={field.value} className="config-check">
                <input
                  type="checkbox"
                  checked={config.narration.fields.includes(field.value)}
                  onChange={() => handleNarrationFieldToggle(field.value)}
                />
                <span>{field.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="config-field">
          <label>Delimiter / symbol</label>
          <select
            value={config.narration.symbol}
            onChange={(event) => updateSection("narration", "symbol", event.target.value)}
          >
            {["!", "@", "#", "$", "%", "^", "&", "*"].map((symbol) => (
              <option key={symbol} value={symbol}>
                {symbol}
              </option>
            ))}
          </select>
        </div>
      </Section>

      <Section
        title="5. Unplanned Cost"
        subtitle="Handle costs not considered at PO stage"
        open={openSections.unplanned}
        onToggle={() => toggleSection("unplanned")}
      >
        <div className="config-field">
          <label>Add unplanned cost to Material / Service?</label>
          <RadioGroup
            name="add_to_material_service"
            value={config.unplanned_cost.add_to_material_service}
            options={[
              { value: "Y", label: "Yes" },
              { value: "N", label: "No" },
            ]}
            onChange={(value) => updateSection("unplanned_cost", "add_to_material_service", value)}
          />
          <p className="config-note">
            {config.unplanned_cost.add_to_material_service === "Y"
              ? "Same GL code will be used for Unallocated Cost which is already used for other items."
              : "User must select a GL code from dropdown while submitting Unallocated Cost."}
          </p>
        </div>

        <div className="config-grid">
          <div className="config-rule">
            <h3>Processor Rule</h3>
            <input
              type="number"
              value={config.unplanned_cost.processor.threshold_amount}
              onChange={(event) =>
                updateNested("unplanned_cost", "processor", "threshold_amount", event.target.value)
              }
              placeholder="Amount limit"
            />
            <select
              value={config.unplanned_cost.processor.condition}
              onChange={(event) =>
                updateNested("unplanned_cost", "processor", "condition", event.target.value)
              }
            >
              <option value="AND">AND</option>
              <option value="OR">OR</option>
            </select>
            <input
              type="number"
              min="0"
              max="99"
              value={config.unplanned_cost.processor.threshold_percent}
              onChange={(event) =>
                updateNested("unplanned_cost", "processor", "threshold_percent", event.target.value)
              }
              placeholder="Percentage limit"
            />
          </div>

          <div className="config-rule">
            <h3>Checker Rule</h3>
            <input
              type="number"
              value={config.unplanned_cost.checker.threshold_amount}
              onChange={(event) =>
                updateNested("unplanned_cost", "checker", "threshold_amount", event.target.value)
              }
              placeholder="Amount limit"
            />
            <select
              value={config.unplanned_cost.checker.condition}
              onChange={(event) =>
                updateNested("unplanned_cost", "checker", "condition", event.target.value)
              }
            >
              <option value="AND">AND</option>
              <option value="OR">OR</option>
            </select>
            <input
              type="number"
              min="0"
              max="99"
              value={config.unplanned_cost.checker.threshold_percent}
              onChange={(event) =>
                updateNested("unplanned_cost", "checker", "threshold_percent", event.target.value)
              }
              placeholder="Percentage limit"
            />
          </div>
        </div>
      </Section>

      <Section
        title="6. Matching Logic"
        subtitle="Matching tolerances"
        open={openSections.matchingLogic}
        onToggle={() => toggleSection("matchingLogic")}
      >

        <h4 style={{ marginBottom: "10px" }}>
          a. 2/3 Way Match Ratio
        </h4>

        <div className="config-grid">
          <div className="config-field">
            <label>Fuzzy Ratio</label>
            <input
              value={config.matching_logic.fuzzyratio}
              onChange={(event) =>
                updateSection("matching_logic", "fuzzyratio", event.target.value)
              }
            />
          </div>

          <div className="config-field">
            <label>Sementic Ratio</label>
            <input
              value={config.matching_logic.sementicratio}
              onChange={(event) =>
                updateSection("matching_logic", "sementicratio", event.target.value)
              }
            />
          </div>

          <div className="config-field">
            <label>Matching Tolerance %</label>
            <input
              value={config.matching_logic.matching_tolerance}
              onChange={(event) =>
                updateSection(
                  "matching_logic",
                  "matching_tolerance",
                  event.target.value
                )
              }
            />
          </div>
        </div>

        <h4 style={{ margin: "24px 0 10px" }}>
          b. Address Matching Ratio
        </h4>

        <div className="config-grid">
          <div className="config-field">
            <label>Fuzzy Ratio</label>
            <input
              value={config.address_matching_threshold.fuzzyratio}
              onChange={(event) =>
                updateSection(
                  "address_matching_threshold",
                  "fuzzyratio",
                  event.target.value
                )
              }
            />
          </div>

          <div className="config-field">
            <label>Sementic Ratio</label>
            <input
              value={config.address_matching_threshold.sementicratio}
              onChange={(event) =>
                updateSection(
                  "address_matching_threshold",
                  "sementicratio",
                  event.target.value
                )
              }
            />
          </div>

          <div className="config-field">
            <label>Matching Tolerance %</label>
            <input
              value={config.address_matching_threshold.matching_tolerance}
              onChange={(event) =>
                updateSection(
                  "address_matching_threshold",
                  "matching_tolerance",
                  event.target.value
                )
              }
            />
          </div>
        </div>

      </Section>
  
    </section>
  );
}
